<template>
    <div>
        <button class="btn btn-sm btn-dark mb-1" v-on:click="back">
            <feather-icon icon="ArrowLeftIcon" class="mr-25"></feather-icon>Geri
        </button>
        <form-wizard color="#1F4690" error-color="#1F4690" :title="null" :subtitle="null" shape="square" layout="vertical" class="wizard-vertical mb-3">
            <tab-content title="Firma Bilgileri">
                <firm-create-or-update-info v-model="firm.Info"></firm-create-or-update-info>
            </tab-content>
            <tab-content title="Adres Bilgileri" >
                <firm-location v-model="firm.Locations"></firm-location>
            </tab-content>
            <tab-content title="İletişim Bilgileri">
                <firm-contact v-model="firm.Contacts" :locations="firm.Locations"></firm-contact>
            </tab-content>
            <template #finish>
                <button v-on:click="createFirm" class="btn btn-primary">
                    <b-spinner v-if="loading" class="mr-1" small></b-spinner>
                    Oluştur 
                </button>
            </template>
            <template #prev>
                <button class="btn btn-outline-primary">
                    <feather-icon icon="ChevronLeftIcon" class="mr-50"></feather-icon>
                    Önceki
                </button>
            </template>
            <template #next>
                <button class="btn btn-primary d-flex align-items-center">
                    Sonraki
                    <feather-icon icon="ChevronRightIcon" class="ml-50"></feather-icon>
                </button>
            </template>
        </form-wizard>
    </div>
</template>

<script>
import { FormWizard,TabContent } from "vue-form-wizard"
import {BSpinner} from "bootstrap-vue" 
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import FirmCreateOrUpdateInfo from '@/views/firm-operations/firm/components/FirmCreateOrUpdateInfo'
import FirmContact from '@/views/firm-operations/firm/components/FirmContact'
import FirmLocation from '@/views/firm-operations/firm/components/FirmLocation'
import FirmOperationsApi from '@/api/firm-operations'
import Additional from '@/utilities/additional'

export default {
    components:{
        FormWizard,
        TabContent,
        BSpinner,
        FirmCreateOrUpdateInfo,
        FirmContact,
        FirmLocation
    },
    data(){
        return {
            loading:false,
            firm:{
                Info:{
                    Name:null,
                    FirmShortName:null,
                    ParentFirmId:null,
                    SectorTypeIds:[],
                    TaxAdministrationId:null,
                    TaxNumber:null,
                    Logo:null,
                    IsCompany:true,
                    FirmRole: '1', //  1 = General | 5 = Fuel Supplier
                },
                Locations:[],
                Contacts:[]
            }
        }
    },
    methods:{
        async createFirm(){
            let data = {
                FirmContacts: this.firm.Contacts,
                FirmLocations: this.firm.Locations,
                FirmInformation: this.firm.Info
            }
            this.loading = true
            let formData = await Additional.ToFormData(data,["FirmInformation.Logo"])
            FirmOperationsApi.Create(formData).then(res => {
                this.$result(res)
                if(res.data.Success){
                    this.loading = false
                    this.$router.push({name:'firm-operations'})
                }
            }).catch(err => {
                this.loading = false
                this.$result(null,err)
            })
        },
        back(){
            this.$router.push({name:'firm-operations'})
        },
    }
}
</script>


<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>